import React, {useEffect, useMemo, useState} from "react";
import axios from "axios";
import { toast } from "react-toastify";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

function ClaimModal({ open, onClose, selectedCashBook, selectedReimbursements = [],onSuccess , editData = null }) {

    const [amount, setAmount] = useState("");
    const [description, setDescription] = useState("");
    const [loading, setLoading] = useState(false);

    const token = sessionStorage.getItem("token");

    const isReimbursementClaim = selectedReimbursements.length > 0;

    const totalAmount = useMemo(() => {

        return selectedReimbursements.reduce(
            (sum, item) =>
                sum +
                Number(
                    item.remaining_claimable_amount ||
                    item.amount ||
                    0
                ),
            0
        );

    }, [selectedReimbursements]);

    const normalizeMoney = (value) => {

        const num = parseFloat(value);

        if (isNaN(num)) {
            return 0;
        }

        return num;
    };

    const finalAmount = isReimbursementClaim ? normalizeMoney(totalAmount) : normalizeMoney(amount);

    const isEditReimbursementClaim =
        editData &&
        editData.related_reimbursements?.length > 0;

    useEffect(() => {

        if (editData) {

            setAmount(editData.amount || "");

            setDescription(editData.description || "");
        }

    }, [editData]);

    const handleSubmit = async () => {

        if (!selectedCashBook?._id) {
            return toast.error("CashBook not selected");
        }


        if (!finalAmount || finalAmount <= 0) {
            return toast.error("Valid amount required");
        }

        try {

            setLoading(true);

            const payload = {
                cash_book: selectedCashBook._id,
                category: selectedCashBook?.category?._id || selectedCashBook?.category,
                transaction_type: "Claim",
                amount: finalAmount,
                related_reimbursements: isReimbursementClaim
                    ? selectedReimbursements.map((r) => ({
                        reimbursement_id: r._id,
                        amount:
                            Number(
                                r.remaining_claimable_amount ||
                                r.amount ||
                                0
                            )
                    }))
                    : [],
                description: description?.trim()
            };

            if (editData) {

                await axios.put(
                    `${API_BASE_URL}/pettycash/update-claim/${editData._id}`,
                    {
                        amount: finalAmount,
                        description
                    },
                    {
                        headers: {
                            Authorization: `Bearer ${token}`
                        }
                    }
                );

            } else {

                await axios.post(
                    `${API_BASE_URL}/pettycash/transaction`,
                    payload,
                    {
                        headers: {
                            Authorization: `Bearer ${token}`
                        }
                    }
                );
            }

            toast.success(
                editData
                    ? "Claim updated"
                    : "Claim submitted"
            );

            setAmount("");
            setDescription("");

            onClose();

            if (onSuccess) onSuccess();

        } catch (err) {
            toast.error(err.response?.data?.message || "Error");
        } finally {
            setLoading(false);
        }
    };



    if (!open) return null;

    return (
        <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50 p-4">

            <div className="bg-white rounded-2xl shadow-2xl w-[520px] max-w-[95vw] max-h-[90vh] flex flex-col  overflow-hidden">

                {/* HEADER */}
                <div className="shrink-0 bg-blue-600 text-white px-6 py-4 flex justify-between items-center">
                    <h2 className="text-lg font-semibold">
                        {isReimbursementClaim
                            ? "Create Reimbursement Claim"
                            : "Create Claim"}
                    </h2>

                    <button onClick={onClose} className="text-2xl leading-none">×</button>
                </div>

                {/* BODY */}
                <div className=" flex-1 overflow-y-auto p-6 space-y-4 custom-scrollbar scroll-smooth">

                    {/* CATEGORY */}
                    <div>
                        <label className="block mb-2 font-medium">
                            Category
                        </label>

                        <input
                            value={selectedCashBook?.category?.category_name || ""}
                            readOnly
                            className="w-full border px-4 py-2 rounded-lg bg-gray-100"
                        />
                    </div>

                    {/* CASHBOOK */}
                    <div>
                        <label className="block mb-2 font-medium">
                            Cash Book
                        </label>

                        <input
                            value={selectedCashBook?.cash_book_code || ""}
                            readOnly
                            className="w-full border px-4 py-2 rounded-lg bg-gray-100"
                        />
                    </div>

                    {isReimbursementClaim && (

                        <>
                            {/* SELECTED REIMBURSEMENTS */}
                            <div>

                                <label className="block mb-2 font-medium">
                                    Selected Reimbursements
                                </label>

                                <div className="border rounded-lg bg-gray-50 p-3 max-h-48 overflow-y-auto">

                                    {selectedReimbursements.map((item) => (

                                        <div
                                            key={item._id}
                                            className="flex justify-between py-2 text-sm border-b last:border-b-0"
                                        >

                                            <span>
                                                {item.transaction_code}
                                            </span>

                                            <span>
                                                Rs {Number(
                                                item.remaining_claimable_amount ||
                                                item.amount ||
                                                0
                                            ).toLocaleString()}
                                            </span>

                                        </div>

                                    ))}

                                </div>

                            </div>

                            {/* TOTAL */}
                            <div>

                                <label className="block mb-2 font-medium">
                                    Total Claim Amount
                                </label>

                                <input
                                    readOnly
                                    value={`Rs ${totalAmount.toLocaleString()}`}
                                    className="w-full border px-4 py-3 rounded-lg bg-gray-100 font-semibold"
                                />

                            </div>
                        </>
                    )}

                    {/* AMOUNT */}
                    {!isReimbursementClaim && (



                        <div>

                            <label className="block mb-2 font-medium">
                                Amount
                            </label>

                            <input
                                type="number"
                                disabled={isEditReimbursementClaim}
                                step="any"
                                min="1"
                                value={amount}
                                onChange={(e) =>
                                    setAmount(e.target.value)
                                }
                                placeholder="Enter amount"
                                className="w-full border px-4 py-3 rounded-lg outline-none focus:ring-2 focus:ring-blue-500"
                            />

                        </div>
                    )}

                    {/* DESCRIPTION */}
                    <div>
                        <label className="block mb-2 font-medium">
                            Description
                        </label>

                        <textarea
                            value={description}
                            onChange={(e) => setDescription(e.target.value)}
                            rows="3"
                            className="w-full border px-4 py-3 rounded-lg resize-none outline-none focus:ring-2 focus:ring-blue-500"
                        />
                    </div>

                    {/* ACTIONS */}
                    <div className="shrink-0 flex justify-end gap-3 p-5  border-t bg-white">

                        <button
                            onClick={onClose}
                            disabled={loading}
                            className="px-5 py-2 rounded-lg bg-gray-300 hover:bg-gray-400 transition"
                        >
                            Cancel
                        </button>

                        <button
                            onClick={handleSubmit}
                            disabled={loading}
                            className={`px-5 py-2 rounded-lg transition ${
                                loading
                                    ? "bg-gray-400 text-white cursor-not-allowed"
                                    : "bg-blue-600 hover:bg-blue-700 text-white"
                            }`}
                        >
                            {loading ? "Saving..." : "Submit"}
                        </button>

                    </div>

                </div>
            </div>
        </div>
    );
}

export default ClaimModal;